<div class="acesso__form">
  <header class="form__header" *ngIf="etapaAtual !== ETAPA__CONFIRMACAO">
    <p class="header__voltar__acesso" (click)="irParaAcesso()">
      <svg
        class="voltar__icone"
        width="12"
        height="20"
        viewBox="0 0 12 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 2L2 10L10 18"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      {{ etapaAtual === ETAPA__ENVIO ? "Lembrei" : "Voltar" }}
    </p>
  </header>
  <div class="etapa" *ngIf="etapaAtual === ETAPA__ENVIO">
    <p class="form__esqueci">Esqueceu sua senha?</p>
    <p class="texto_esquerdo">Deixa comigo, Lover.</p>
    <p class="texto_esquerdo">Digite seu CPF e escolha uma opção para</p>
    <p class="texto_esquerdo">receber um código de redefinição da senha.</p>

    <div class="lovers-input__container container__cpf">
      <input
        id="email"
        (input)="verificaCPF()"
        type="text"
        class="lovers-input input__esqueci"
        pattern="[0-9]"
        inputmode="numeric"
        placeholder=" "
        mask="000.000.000-00"
        name="cpf"
        [(ngModel)]="cpf"
      />
      <label for="cpf" class="lovers-label">CPF</label>
      <div *ngIf="exibeErro">
        <label class="text-danger"> Campo obrigatório! </label>
      </div>
    </div>

    <button
      id="continuarCelular"
      class="lovers-button"
      [ngClass]="{ disabledButton: realizandoEnvioCelular }"
      (click)="enviarCodigo('celular')"
      type="button"
    >
      <svg
        *ngIf="!realizandoEnvioCelular"
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 12.75H10.25M7.25 15.75H11.75C12.9927 15.75 14 14.7427 14 13.5V4.5C14 3.25736 12.9927 2.25 11.75 2.25H7.25C6.00736 2.25 5 3.25736 5 4.5V13.5C5 14.7427 6.00736 15.75 7.25 15.75Z"
          stroke="white"
          stroke-width="1.125"
          stroke-linecap="round"
        />
      </svg>
      <i *ngIf="realizandoEnvioCelular" class="fa fa-spinner fa-spin"></i>
      Continuar com celular
    </button>

    <button
      class="lovers-button"
      type="button"
      [ngClass]="{ disabledButton: realizandoEnvioEmail }"
      (click)="enviarCodigo('email')"
    >
      <svg
        *ngIf="!realizandoEnvioEmail"
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.8553 15.0001H5.70436C3.55909 15.0001 2.12891 13.9274 2.12891 11.4246V6.41896C2.12891 3.91614 3.55909 2.84351 5.70436 2.84351H12.8553C15.0006 2.84351 16.4307 3.91614 16.4307 6.41896V11.4246C16.4307 13.9274 15.0006 15.0001 12.8553 15.0001Z"
          stroke="white"
          stroke-width="1.07264"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1197 5.896L10.1531 8.96109C9.63802 9.35904 8.91921 9.35904 8.40413 8.96109L4.4375 5.896"
          stroke="white"
          stroke-width="1.07264"
          stroke-linecap="round"
        />
      </svg>

      <i *ngIf="realizandoEnvioEmail" class="fa fa-spinner fa-spin"></i>
      Continuar com e-mail
    </button>

    <p class="form__descritivo">
      Caso o e-mail e/ou número cadastrado não esteja mais em uso ou você nunca
      realizou cadastro no programa de fidelidade Cacau Lovers, entre em contato
      via telefone: 4004-2987 (capitais e região metropolitana) ou 0800 11 9263
      (demais regiões). Horário de atendimento: segunda a sexta-feira das 08:00
      às 17:00 e aos sábados das 09:00 às 15:30 ou acesse: <a href="https://lovers.cacaushow.com.br/ajuda/cacaulovers">https://lovers.cacaushow.com.br/ajuda/cacaulovers</a>.
    </p>
  </div>
  <div class="etapa" *ngIf="etapaAtual === ETAPA__PINCODE">
    <div class="resumo">
      <svg
        width="91"
        height="44"
        viewBox="0 0 91 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 26.7471V36H0V33.591H2.72405C3.481 33.591 3.89684 33.1708 3.89684 32.4064V13.5563C3.89684 12.7919 3.481 12.3707 2.72405 12.3707H0V10H13.0545V12.3707H9.34638C8.58943 12.3707 8.17358 12.7919 8.17358 13.5563V33.5915H14.6436C18.0489 33.5915 18.3138 30.4181 18.6166 26.7471H21Z"
          fill="white"
        />
        <path
          d="M36 31.9043C36 37.7772 31.8843 42 26.5184 42C21.1161 42 17 37.7772 17 31.9043C17 26.1081 21.1161 22 26.5184 22C31.8839 22 36 26.1081 36 31.9043ZM31.9206 31.9043C31.9206 26.7988 29.9728 24.0735 26.5179 24.0735C23.063 24.0735 21.1157 26.7988 21.1157 31.9043C21.1157 37.1249 23.063 39.9654 26.5179 39.9654C29.9728 39.9654 31.9206 37.1249 31.9206 31.9043Z"
          fill="white"
        />
        <path
          d="M53 19V21.3798H51.872C51.0069 21.3798 50.4055 21.7577 50.0665 22.5511L43.2601 38H40.8156L34.084 22.5511C33.7454 21.7572 33.1436 21.3798 32.316 21.3798H31V19H41.3041V21.3798H39.311C38.5592 21.3798 38.183 21.8328 38.4463 22.4755L42.8459 33.3159L47.622 22.4755C47.8853 21.8328 47.5468 21.3798 46.795 21.3798H45.2904V19H53Z"
          fill="white"
        />
        <path
          d="M59.0135 37.5809C62.0882 37.5809 64.1507 35.6615 64.7879 32.6674L66.8504 33.0514C65.9507 37.3126 62.9875 40 58.4124 40C52.7499 40 49 35.8156 49 30.1341C49 24.3764 52.8625 20 58.3749 20C63.6256 20 67 24.0692 67 29.8659C67 30.1346 67 30.3645 66.9625 30.7101H53.2371C53.4631 34.8168 55.3756 37.5809 59.0135 37.5809ZM53.238 28.7907H62.9505C62.7629 24.3759 61.4135 22.0725 58.4503 22.0725C55.4506 22.0725 53.5006 24.6442 53.238 28.7907Z"
          fill="white"
        />
        <path
          d="M82 20.8625C82 22.3502 80.9336 23.5022 79.4987 23.5022C78.1752 23.5022 77.1814 22.6844 77.1814 21.3083C77.1814 20.9736 77.255 20.6765 77.3654 20.3789C75.0848 20.862 72.9892 23.2791 72.6939 29.6377V33.5053C72.6939 34.2487 73.0991 34.6573 73.8344 34.6573H77.2913V37H66V34.6573H67.8018C68.5381 34.6573 68.9423 34.2487 68.9423 33.5053V21.7928C68.9423 21.0484 68.5381 20.6398 67.8018 20.6398H66V18.2971H72.6935V23.5399C73.9076 19.7476 76.1513 18 78.8365 18C80.7128 17.9995 82 19.1902 82 20.8625Z"
          fill="white"
        />
        <path
          d="M91 38.1272C91 41.7735 88.1736 44 83.5754 44C78.9772 44 76 41.7351 76 38.933C76 37.3588 76.942 36.3993 78.2991 36.3993C79.6176 36.3993 80.5596 37.2436 80.5596 38.5875C80.5596 39.6621 79.9569 40.4684 78.8264 40.6604C79.7684 41.5047 81.2009 42.1569 83.0476 42.1569C85.7986 42.1569 87.193 40.7756 87.193 38.971C87.193 33.8656 76.3388 36.4372 76.3388 29.4893C76.3388 25.8431 79.2783 24 83.5749 24C87.9469 24 90.5476 25.9578 90.5476 28.4147C90.5476 29.9496 89.567 30.91 88.2108 30.91C86.8914 30.91 85.9494 29.988 85.9494 28.7603C85.9494 27.7624 86.5521 27.1092 87.4564 26.8409C86.6652 26.1886 85.5724 25.8431 84.1399 25.8431C81.6146 25.8431 80.0318 26.9561 80.0318 28.7219C80.0323 33.3674 91 30.9873 91 38.1272Z"
          fill="white"
        />
        <path
          d="M27 8.93985C26.3862 12.3001 24.3207 14 21.4932 14C17.7167 14 15 10.9799 15 7C15 2.99987 17.7349 0 21.4932 0C24.9907 0 26.907 2.58019 26.907 4.29984C26.907 5.33963 26.2188 5.85999 25.4932 5.85999C24.6933 5.85999 24.1538 5.27988 24.1538 4.52003C24.1538 3.84017 24.5446 3.38002 25.1398 3.23982C24.712 2.43998 23.8004 1.25998 21.8097 1.25998C19.1122 1.25998 17.3819 3.36026 17.3819 6.92002C17.3819 10.46 19.0565 12.66 21.6423 12.66C23.7073 12.66 25.2328 11.2598 25.8284 8.64014L27 8.93985Z"
          fill="white"
        />
        <path
          d="M38 12.5988V13.8081H35.0497L34.5346 12.541C33.9803 13.4432 32.891 14 31.5843 14C29.5247 14 28 12.7524 28 11.0825C28 9.48948 29.5247 8.26082 31.5843 8.26082C32.8119 8.26082 33.842 8.70243 34.4162 9.50845V7.49318C34.4162 5.97688 33.5449 5.0363 32.0202 5.0363C31.6833 5.0363 30.9906 5.07469 30.3766 5.40116C30.8319 5.53572 31.1489 5.95792 31.1489 6.47629C31.1489 7.16716 30.5945 7.72392 29.8222 7.72392C29.0699 7.72392 28.5349 7.18658 28.5349 6.45688C28.5349 5.15145 30.2975 4 32.4556 4C34.8715 4 36.4161 5.32439 36.4161 7.45525V12.0046C36.4161 12.3884 36.634 12.5997 37.0301 12.5997H38V12.5988ZM34.4157 11.0631C34.4157 10.0458 33.4653 9.3355 32.2969 9.3355C31.0887 9.3355 30.198 10.0842 30.198 11.0821C30.198 12.061 31.0892 12.8097 32.2969 12.8097C33.4653 12.8102 34.4157 12.0999 34.4157 11.0631Z"
          fill="white"
        />
        <path
          d="M46 10.5259C45.4961 12.9059 43.9646 14 41.892 14C39.0538 14 37 11.9654 37 9.04809C37 6.01562 39.2405 4 41.9108 4C44.3756 4 45.9442 5.72755 45.9442 7.28216C45.9442 8.03079 45.4215 8.56811 44.7491 8.56811C43.9833 8.56811 43.4606 8.06917 43.4606 7.3395C43.4606 6.82115 43.7966 6.32221 44.3568 6.16869C43.9646 5.55461 43.3109 5.13198 42.2097 5.13198C40.0626 5.13198 39.0725 6.68659 39.0725 8.89411C39.0725 11.3509 40.2301 12.7714 42.1534 12.7714C43.5352 12.7714 44.6369 12.0228 44.9729 10.3336L46 10.5259Z"
          fill="white"
        />
        <path
          d="M57 12.5988V13.8081H54.0497L53.5346 12.541C52.9803 13.4432 51.891 14 50.5843 14C48.5247 14 47 12.7524 47 11.0825C47 9.48948 48.5247 8.26082 50.5843 8.26082C51.8119 8.26082 52.8419 8.70243 53.4162 9.50845V7.49318C53.4162 5.97688 52.5449 5.0363 51.0202 5.0363C50.6833 5.0363 49.9906 5.07469 49.3766 5.40116C49.8319 5.53572 50.1489 5.95792 50.1489 6.47629C50.1489 7.16716 49.5945 7.72392 48.8222 7.72392C48.0699 7.72392 47.5349 7.18658 47.5349 6.45688C47.5349 5.15145 49.2975 4 51.4556 4C53.8715 4 55.4161 5.32439 55.4161 7.45525V12.0046C55.4161 12.3884 55.634 12.5997 56.0301 12.5997H57V12.5988ZM53.4157 11.0631C53.4157 10.0458 52.4653 9.3355 51.2969 9.3355C50.0887 9.3355 49.198 10.0842 49.198 11.0821C49.198 12.061 50.0892 12.8097 51.2969 12.8097C52.4653 12.8102 53.4157 12.0999 53.4157 11.0631Z"
          fill="white"
        />
        <path
          d="M67 12.5771V13.8051H63.6124V11.8366C62.9609 13.1425 61.8258 14 60.4484 14C58.7548 14 57.4705 12.7133 57.4705 10.9204V5.67691C57.4331 5.3651 57.2287 5.22845 56.9307 5.22845H56V4.00046H59.3876V10.5691C59.3876 11.7389 60.1322 12.5377 61.2117 12.5377C62.2911 12.5377 63.6129 11.7582 63.6129 9.28247V5.81264C63.6129 5.42287 63.3893 5.22799 63.0357 5.22799H62.2168V4H65.5113V11.9723C65.5113 12.3621 65.7161 12.5767 66.0884 12.5767H67V12.5771Z"
          fill="white"
        />
      </svg>

      <h1 class="form__esqueci">Código para redefinição de senha</h1>
      <p class="texto_esquerdo">
        Digite o código que enviamos para {{ paraEnviarCodigo }}
      </p>
    </div>
    <ng-otp-input
      [config]="otpInputConfig"
      (onInputChange)="validarCodigo($event)"
    >
    </ng-otp-input>
    <div *ngIf="!habilitarSenha">
      <p class="reenviar" *ngIf="!habilitaReenvio">
        Reenviar código em {{ counter }} segundos
      </p>
      <p class="codigo__invalido" *ngIf="habilitaCodigoInvalido">
        Código inválido
      </p>
      <button
        type="button"
        (click)="reenviarCodigo()"
        class="button__reenviar"
        *ngIf="habilitaReenvio"
      >
        Reenviar código
      </button>
    </div>
    <div class="naoRecebeuCodigo" *ngIf="habilitaMsgNaoEnvio">
      <p>
        Não recebeu o código ou seu contato não está mais em uso? Tente
        novamente ou entre em contato com o SAC através do e-mail
        <b>sac@cacaushow.com.br</b> para solicitar a mudança.
      </p>
    </div>
    <div *ngIf="habilitarSenha">
      <div class="divisoria" *ngIf="!naoPossuiSenha">
        <p>redefinição de senha</p>
      </div>
      <div class="lovers-input__container">
        <input
          id="senha"
          [type]="mostrarSenha ? 'text' : 'password'"
          class="lovers-input"
          placeholder=" "
          [(ngModel)]="senha"
        />
        <label for="" class="lovers-label">Senha</label>
        <div class="olho" type="button" (click)="visualizarSenha()">
          <svg
            *ngIf="!mostrarSenha"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M1.66797 8.33334C1.66797 8.33334 4.58464 11.6667 10.0013 11.6667C15.418 11.6667 18.3346 8.33334 18.3346 8.33334M3.33464 9.70418L1.66797 11.6667M18.3346 11.6667L16.6713 9.70668M7.42964 11.4L6.66797 13.75M12.5538 11.4067L13.3346 13.75"
              stroke="#9A2225"
              stroke-width="1.38889"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <svg
            *ngIf="mostrarSenha"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.2899 11.0983C3.21529 11.302 3.06421 11.4686 2.86875 11.5626C2.67328 11.6567 2.44885 11.6708 2.24313 11.602C2.03742 11.5332 1.86663 11.387 1.76706 11.1942C1.66749 11.0015 1.64698 10.7776 1.7099 10.57C1.69323 10.62 1.7099 10.5683 1.7099 10.5683C1.73954 10.4766 1.77403 10.3864 1.81323 10.2983C1.8799 10.14 1.97823 9.92167 2.11323 9.66333C2.38823 9.14667 2.81657 8.45833 3.44823 7.77C4.72323 6.37833 6.81157 5 9.9999 5C13.1882 5 15.2766 6.37833 16.5516 7.77C17.2321 8.51663 17.7841 9.37101 18.1849 10.2983L18.2616 10.4867C18.2666 10.5 18.2832 10.5867 18.2999 10.67L18.3332 10.8333C18.3332 10.8333 18.4732 11.3883 17.7632 11.6233C17.5541 11.6932 17.3259 11.6773 17.1285 11.5792C16.9311 11.4811 16.7806 11.3088 16.7099 11.1V11.095L16.6999 11.0683C16.6162 10.8542 16.5205 10.645 16.4132 10.4417C16.1169 9.88253 15.7506 9.36336 15.3232 8.89667C14.3066 7.78833 12.6449 6.66667 9.9999 6.66667C7.3549 6.66667 5.69323 7.78833 4.67657 8.89667C4.12613 9.50012 3.67851 10.1898 3.35157 10.9383C3.33408 10.9813 3.31741 11.0247 3.30157 11.0683L3.2899 11.0983ZM6.66657 11.6667C6.66657 10.7826 7.01776 9.93477 7.64288 9.30964C8.268 8.68452 9.11584 8.33333 9.9999 8.33333C10.884 8.33333 11.7318 8.68452 12.3569 9.30964C12.982 9.93477 13.3332 10.7826 13.3332 11.6667C13.3332 12.5507 12.982 13.3986 12.3569 14.0237C11.7318 14.6488 10.884 15 9.9999 15C9.11584 15 8.268 14.6488 7.64288 14.0237C7.01776 13.3986 6.66657 12.5507 6.66657 11.6667Z"
              fill="#841702"
            />
          </svg>
        </div>
      </div>

      <div class="senha__requisito">
        <app-validete-password [valuePassword]="senha" (passwordValidate)="passwordValidateFunc($event)" />
      </div>

      <div class="lovers-input__container">
        <input
          id="confirmarSenha"
          [type]="mostrarConfirmaSenha ? 'text' : 'password'"
          class="lovers-input"
          placeholder=" "
          [(ngModel)]="senhaConfirma"
        />
        <label for="" class="lovers-label">Confirme sua senha</label>
        <div class="olho" type="button" (click)="visualizarConfirmaSenha()">
          <svg
            *ngIf="!mostrarConfirmaSenha"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M1.66797 8.33334C1.66797 8.33334 4.58464 11.6667 10.0013 11.6667C15.418 11.6667 18.3346 8.33334 18.3346 8.33334M3.33464 9.70418L1.66797 11.6667M18.3346 11.6667L16.6713 9.70668M7.42964 11.4L6.66797 13.75M12.5538 11.4067L13.3346 13.75"
              stroke="#9A2225"
              stroke-width="1.38889"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <svg
            *ngIf="mostrarConfirmaSenha"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.2899 11.0983C3.21529 11.302 3.06421 11.4686 2.86875 11.5626C2.67328 11.6567 2.44885 11.6708 2.24313 11.602C2.03742 11.5332 1.86663 11.387 1.76706 11.1942C1.66749 11.0015 1.64698 10.7776 1.7099 10.57C1.69323 10.62 1.7099 10.5683 1.7099 10.5683C1.73954 10.4766 1.77403 10.3864 1.81323 10.2983C1.8799 10.14 1.97823 9.92167 2.11323 9.66333C2.38823 9.14667 2.81657 8.45833 3.44823 7.77C4.72323 6.37833 6.81157 5 9.9999 5C13.1882 5 15.2766 6.37833 16.5516 7.77C17.2321 8.51663 17.7841 9.37101 18.1849 10.2983L18.2616 10.4867C18.2666 10.5 18.2832 10.5867 18.2999 10.67L18.3332 10.8333C18.3332 10.8333 18.4732 11.3883 17.7632 11.6233C17.5541 11.6932 17.3259 11.6773 17.1285 11.5792C16.9311 11.4811 16.7806 11.3088 16.7099 11.1V11.095L16.6999 11.0683C16.6162 10.8542 16.5205 10.645 16.4132 10.4417C16.1169 9.88253 15.7506 9.36336 15.3232 8.89667C14.3066 7.78833 12.6449 6.66667 9.9999 6.66667C7.3549 6.66667 5.69323 7.78833 4.67657 8.89667C4.12613 9.50012 3.67851 10.1898 3.35157 10.9383C3.33408 10.9813 3.31741 11.0247 3.30157 11.0683L3.2899 11.0983ZM6.66657 11.6667C6.66657 10.7826 7.01776 9.93477 7.64288 9.30964C8.268 8.68452 9.11584 8.33333 9.9999 8.33333C10.884 8.33333 11.7318 8.68452 12.3569 9.30964C12.982 9.93477 13.3332 10.7826 13.3332 11.6667C13.3332 12.5507 12.982 13.3986 12.3569 14.0237C11.7318 14.6488 10.884 15 9.9999 15C9.11584 15 8.268 14.6488 7.64288 14.0237C7.01776 13.3986 6.66657 12.5507 6.66657 11.6667Z"
              fill="#841702"
            />
          </svg>
        </div>
      </div>

      <button
        id="confirmar"
        class="lovers-button confirma"
        [ngClass]="{ disabled: salvandoSenha, disabled: !passwordValidate }"
        (click)="confirmarResetSenha()"
      >
        <i *ngIf="salvandoSenha" class="fa fa-spinner fa-spin"></i>
        Confirmar
      </button>
    </div>
  </div>
  <div class="etapa" *ngIf="etapaAtual === ETAPA__CONFIRMACAO">
    <div class="confirmacaoSenha">
      <svg
        width="125"
        height="124"
        viewBox="0 0 125 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="62.5" cy="62" r="62" fill="#F9DDD8" />
        <g clip-path="url(#clip0_17310_63230)">
          <rect
            width="77"
            height="77"
            transform="translate(23.5 23)"
            fill="#F9DDD8"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M54.0357 34.7305C57.8742 29.3564 65.8614 29.3564 69.7001 34.7305L70.3113 35.5861C70.9867 36.5319 72.1211 37.0383 73.2761 36.91L76 36.6073C82.1305 35.9262 87.3103 41.1061 86.6292 47.2364L86.3267 49.9603C86.1983 51.1155 86.7046 52.2498 87.6504 52.9253L88.5061 53.5365C93.88 57.3749 93.88 65.3621 88.5061 69.2009L87.6504 69.812C86.7046 70.4874 86.1983 71.6219 86.3267 72.7769L86.6292 75.5007C87.3103 81.6312 82.1305 86.8111 76 86.1299L73.2761 85.8274C72.1211 85.6991 70.9867 86.2053 70.3113 87.1512L69.7001 88.0068C65.8614 93.3808 57.8745 93.3808 54.0357 88.0068L53.4246 87.1512C52.749 86.2053 51.6147 85.6991 50.4596 85.8274L47.7356 86.1299C41.6054 86.8111 36.4255 81.6312 37.1066 75.5007L37.4093 72.7769C37.5376 71.6219 37.0312 70.4874 36.0854 69.812L35.2298 69.2009C29.8557 65.3621 29.8557 57.3753 35.2298 53.5365L36.0854 52.9253C37.0312 52.2498 37.5376 51.1155 37.4093 49.9603L37.1066 47.2364C36.4255 41.1061 41.6054 35.9262 47.7356 36.6073L50.4596 36.91C51.6147 37.0383 52.749 36.5319 53.4246 35.5861L54.0357 34.7305ZM73.7615 52.6834C75.0144 53.9363 75.0144 55.9678 73.7615 57.2206L61.5092 69.4729C59.9356 71.0469 57.3836 71.0469 55.81 69.4729L49.9743 63.6373C48.7214 62.3844 48.7214 60.3529 49.9743 59.1001C51.2272 57.8472 53.2586 57.8472 54.5116 59.1001L58.6596 63.2481L69.2243 52.6834C70.4772 51.4304 72.5087 51.4304 73.7615 52.6834Z"
            fill="#732029"
          />
        </g>
        <defs>
          <clipPath id="clip0_17310_63230">
            <rect
              width="77"
              height="77"
              fill="white"
              transform="translate(23.5 23)"
            />
          </clipPath>
        </defs>
      </svg>

      <p class="tituloSenhaRedefinida">Senha redefinida!</p>

      <p class="resumoSenhaRedefinida">
        Boa Lover, com a sua senha redefinida, você pode voltar a navegar aqui
        conosco de forma tranquila e segura.
      </p>

      <button
        id="entrar"
        class="lovers-button confirma"
        [ngClass]="{ disabled: realizandoLoginMembro }"
        (click)="realizarLogin()"
      >
        Entrar
      </button>
    </div>
  </div>
</div>
